import { connect } from "react-redux";
import B2C from "./B2C";
import { bindActionCreators } from "redux";
import {caseStatusUpdateRequest, caseListRequest, rcCaseListingRequest} from "../../../../../../services/redux/CarLoan/action";

const mapStateToProps = (state) => ({
    caseStatusUpdateResponse : state.CarLoan.caseStatusUpdateResponse,
    caseListResponse : state.CarLoan.caseListResponse,
    rcCaseListingResponse : state.CarLoan.rcCaseListingResponse,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        caseStatusUpdateRequest,
        caseListRequest,
        rcCaseListingRequest
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(B2C);